var version = "0.45.0";
var packageInfo = {
	version: version};

export { packageInfo as default, version };
//# sourceMappingURL=package.json.js.map
